import { EyeIcon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import cn from 'classnames';

const PreviewEmptyState = () => (
  <div className="flex flex-1 flex-col items-center justify-center gap-4 px-6 py-16 text-center">
    <div className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-1">
      <HugeiconsIcon icon={EyeIcon} size={24} className="text-primary-4" strokeWidth={2} />
    </div>
    <p className="text-2xl font-semibold text-neutral-7 m-0">No Preview Available</p>
    <p className="text-xl font-regular text-text-tertiary m-0 max-w-sm">
      This section doesn&apos;t have a visual preview.
    </p>
  </div>
);

const BrandingTabSplitLayout = ({
  children,
  preview = null,
  previewTitle = 'Live Preview - Not Interactive',
  previewHeaderExtra = 'This is a preview. Buttons and inputs do not work.',
  className,
  noPadding = false,
  shellClassName,
}) => {
  const hasPreview = preview != null && preview !== false;

  return (
    <div className={cn('w-full', shellClassName)}>
      <div
        className={cn(
          'grid w-full grid-cols-1 gap-6 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)] lg:gap-8 items-start',
          className,
        )}>
        <div className="flex min-w-0 flex-col gap-6">{children}</div>

        <aside className="min-w-0 lg:sticky lg:top-28 lg:self-start">
          <div className="flex min-h-[22rem] flex-col overflow-hidden rounded-3xl border border-neutral-4 bg-white shadow-sm">
            <div className="flex flex-wrap items-center justify-between gap-3 border-b border-neutral-4 px-6 py-4 bg-yellow-2/30">
              <div className="flex min-w-0 items-center gap-2">
                <HugeiconsIcon
                  icon={EyeIcon}
                  size={22}
                  className="shrink-0 text-orange-3"
                  strokeWidth={2}
                />
                <span className="text-xl text-orange-3 font-medium flex items-center gap-2">
                  {previewTitle}
                </span>
              </div>
              {previewHeaderExtra ? (
                <div className="text-lg text-orange-3 font-regular">{previewHeaderExtra}</div>
              ) : null}
            </div>
            <div className="flex min-h-[16rem] flex-1 flex-col overflow-auto bg-neutral-1">
              {hasPreview ? (
                <div className={cn('min-h-0 flex-1', noPadding ? 'p-0' : 'p-6')}>{preview}</div>
              ) : (
                <PreviewEmptyState />
              )}
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default BrandingTabSplitLayout;
